const p8 = (s: boolean) => {
  const p = Math.random().toString(16).substr(2, 8).padEnd(8, '0');
  return s ? `-${p.substr(0, 4)}-${p.substr(4, 4)}` : p;
};

export const generate = () => p8(false) + p8(true) + p8(true) + p8(false);
